/**
 * Stores the RBAC token and permissions in NgRx.
 * Failed requests reset the RBAC state so access is denied by default.
 */
import { createReducer, on } from '@ngrx/store';
import { initialRbacState } from './rbac.state';
import { rbacFailed, rbacLoaded, rbacLoading } from './rbac.action';

export const rbacReducer = createReducer(
  initialRbacState,
  on(rbacLoading, (s) => ({ ...s, status: 'loading' as const })),
  on(rbacLoaded, (_, { response }) => ({
    status: 'loaded' as const,
    rbacToken: response.rbac_token,
    //rbac: { ...response.rbac, permissions: ['finance'] },
    rbac: response.rbac,
  })),
  on(rbacFailed, () => ({ ...initialRbacState, status: 'error' as const }))
);